import React from "react";
import { Alert, AlertProps } from "react-bootstrap";

interface IAlertMessageProps extends AlertProps {}

interface IAlertMessageState {
    show: boolean;
}

export default class AlertMessage extends React.Component<
    IAlertMessageProps,
    IAlertMessageState
> {
    render() {
        return <Alert {...this.props}>{this.props.children}</Alert>;
    }
}
